<template>
  <div class="main-body">
    <div class="header">科室收支</div>
    <div class="out">

      <div class="search2">
<!--        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>-->
<!--        <el-button type="primary" size="mini" plain @click.native="toggleModalSelect">选择科室收支</el-button>-->

        <div style="float:right;">
          <el-select v-model="departmentId" placeholder="请选择科室" style="margin-right: 5px">
            <el-option
                v-for="item in department_arr"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="type" clearable placeholder="请选择类型" style="margin-right: 5px">
            <el-option
                v-for="item in type_arr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="loading" :data="tableData" :height="th" border>

        <el-table-column prop="departmentName" label="科室名称" fixed width="200"></el-table-column>
        <el-table-column prop="name" label="收支项目名称" fixed width="200"></el-table-column>
        <el-table-column prop="type" label="收支类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 'in'">收入</span>
            <span v-if="scope.row.type == 'out'">支出</span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="status" label="状态" width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.status == 1">正常</span>-->
<!--            <span v-if="scope.row.status == 2" style="color: red;">禁用</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="sort" label="排序" ></el-table-column>

<!--        <el-table-column fixed="right" label="操作" width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
<!--            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    <Select ref="mySelect" v-show="showModalSelect" v-on:closeMe="showModalSelect=false" v-on:getList="getList"></Select>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";
import Select from "./Select";

import {getStaffCode,getGovernmentCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,
      showModalSelect:false,

      th:0,

      loading:false,

      type:'',
      type_arr:[{value:'in',label:'收入'},{value:'out',label:'支出'}],

      departmentId: '',
      department_arr:[],

    }
  },
  created(){
    this.getDepartment();
    //this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit,Select
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getDepartment(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/GovList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode:getGovernmentCode(),
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.department_arr = response.data.data.list;
          if(this.department_arr.length>0){
            this.departmentId = this.department_arr[0].id;
            this.getList();
          }
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    toggleModalSelect:function(){
      this.$refs.mySelect.init();
      this.showModalSelect = !this.showModalSelect;
    },
    handleDelete(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "DepartmentInOut/GovDelete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            departmentInOutId:row.id,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList();
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },



    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },


    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      let that = this;
      that.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOut/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          type:this.type,
          departmentId:this.departmentId,
        }
      }).then( (response)=> {
        //console.log(response);
        that.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        that.loading = false;
        console.log(error);
      });
    },






  }
}
</script>

